
import React, { createContext, useContext, useEffect, useState, } from 'react';

import { HandleSession } from 'Session/HandleSession';
import apiUtils from 'utils/apiutils';

export const DataContext = createContext();
export const useProfile = () => {
  return useContext(DataContext);
};

export const DataProvider = ({ children }) => {
  const [profileData, setProfileData] = useState(null)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [myexchanges, setexchanges] = useState([]);
  const [coins, setcoins] = useState([])



  const fetchProfileData = async () => {
    setLoading(true);
    try {
      const response = await apiUtils.post('/user/view_profile', {}, {
        showToast: false,
        setData: setProfileData,
      });
    } catch (err) {
      HandleSession(err)
    } finally {
      setLoading(false);
    }
  };

    const handlegetexchanges = async () => {


    try {
      const jwt = localStorage.getItem('jwt');
      const response = await apiUtils.post(
        '/trades/available-exchanges',
        { showToast: false }
      );
      if (response?.Success) {
        setexchanges(response.Success)
      }
    } catch (err) {

    } finally {

    }
  };

    const handegetcoins = async () => {
    try {
      const jwt = localStorage.getItem('jwt');
      const response = await apiUtils.post(
        '/trades/available-coins',
        { showToast: false }
      );
      if (response.Success) {
        setcoins(response.Success)
      }
    } catch (err) {

    } finally {

    }
  };





  
  return (
    <DataContext.Provider value={{ profileData, myexchanges, coins, handlegetexchanges, handegetcoins, loading, error,fetchProfileData }}>
      {children}
    </DataContext.Provider>
  );
};
